<template>
  <div v-if="customLogoBig && (alwaysExtended || $vuetify.breakpoint.mdAndUp)" class="imgContainer" :style="`height: ${height}px;`">
    <img class="userImg" :src="customLogoBig" />
  </div>
  <div v-else-if="$vuetify.breakpoint.smAndDown && customLogoSmall" class="imgContainer" :style="`height: ${height}px;`">
    <img class="userImg" :src="customLogoSmall" />
  </div>
  <component v-else-if="alwaysExtended || $vuetify.breakpoint.mdAndUp" :is="theme === 'dark' ? 'LogoBigDark' : 'LogoBigLight'"/>
  <component v-else :is="theme === 'dark' ? 'LogoSmallDark' : 'LogoSmallLight'" :style="`height: ${height}px; width: auto;`"/>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    theme: String,
    height: [ Number, String ],
    alwaysExtended: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      customLogoSmall: null,
      customLogoBig: null,
    }
  },
  components: {
    LogoBigLight: () => import('@/../public/goguest-large-light.svg'),
    LogoBigDark: () => import('@/../public/goguest-large-dark.svg'),
    LogoSmallDark: () => import('@/../public/goguest-small-dark.svg'),
    LogoSmallLight: () => import('@/../public/goguest-small-light.svg'),
  },
  computed: {
    ...mapState({
      configuration: state => state.service.configuration,
    }),
  },
  watch: {
    configuration: {
      immediate: true,
      handler: function (newValue, oldValue) {
        if (!!newValue && newValue.customization.logo) {
          if (newValue.customization.logo.compact) {
            if (newValue.customization.logo.compact.startsWith('http') || newValue.customization.logo.compact.startsWith('data:')) {
              this.customLogoSmall = newValue.customization.logo.compact
            } else {
              this.$store.dispatch('service/getPublicFileImage', { fileId: newValue.customization.logo.compact }).then((file) => {
                this.customLogoSmall = file
                this.$store.commit('service/setLogo', { logoPath: 'compact', image: file })
              })
            }
          }
          if (newValue.customization.logo.horizontal) {
            if (newValue.customization.logo.horizontal.startsWith('http') || newValue.customization.logo.horizontal.startsWith('data:')) {
              this.customLogoBig = newValue.customization.logo.horizontal
            } else {
              this.$store.dispatch('service/getPublicFileImage', { fileId: newValue.customization.logo.horizontal }).then((file) => {
                this.customLogoBig = file
                this.$store.commit('service/setLogo', { logoPath: 'horizontal', image: file })
              })
            }
          }
        }
      },
    },
  },
}
</script>

<style lang="scss">
.userImg {
  max-height: 100%;
  max-width: 100%;
}
.imgContainer {
  width: auto;
}
</style>
